<template>
  <div class="order-box">
    <div class="title">{{ $t("我的订单") }}</div>
    <div class="order-list">
      <div class="no-data pt-86" v-if="orderList.length == 0">
        <img src="@/assets/images/empty_data.png" alt="" />
        <p>{{ $t("暂无数据") }}</p>
      </div>
      <div v-for="(item, index) in orderList" :key="index" class="order-item">
        <div class="df fww">
          <div
            class="t1 f1 one-text pr-26"
            :title="item.tgo_number + item.goods_name"
          >
            <span>{{ $t("订单号") }}：{{ item.tgo_number }}</span>
            <span class="ml-16">{{ item.goods_name }}</span>
          </div>
          <div class="fn fs-14 ta-r">
            {{ formatTime(item.tgo_exchange_time * 1000, "YYYY.MM.DD") }}
          </div>
        </div>
        <div class="box2 df">
          <img :src="item.tg_main_image_attr" class="good-img" alt="" />

          <div class="f1 df aic ml-20">
            <div class="f1">
              <div
                class="order-status-timeline df"
                :class="'active-status' + item.tgo_status"
              >
                <div class="status-item">
                  <div class="line">
                    <span class="yuan"></span>
                  </div>
                  <div class="status-text">{{ $t("提交订单") }}</div>
                </div>

                <div class="status-item">
                  <div class="line">
                    <span class="yuan"></span>
                  </div>
                  <div class="status-text">{{ $t("已发货") }}</div>
                </div>

                <div class="status-item">
                  <div class="line">
                    <span class="yuan"></span>
                  </div>
                  <div class="status-text">{{ $t("已送达") }}</div>
                </div>

                <div class="status-item">
                  <div class="line">
                    <span class="yuan"></span>
                  </div>
                  <div class="status-text">{{ $t("已签收") }}</div>
                </div>
              </div>
            </div>

            <div class="order-actions df fn">
              <div style="position: relative">
                <div class="ipt-box df aic" v-if="item.has_unread_feedback">
                  <span
                    class="iconfont fs-18 icon-tishi"
                    style="color: #0a59f7"
                  ></span>
                  <span class="ml-8 c-3 fs-14">{{
                    $t("您有新的反馈答复")
                  }}</span>
                  <span
                    class="iconfont cup ml-8 fs-18 icon-cuo c-0"
                    @click="item.has_unread_feedback = 0"
                  ></span>
                </div>
                <el-button
                  class="btn-detail"
                  @click="showOrderDetail(item.tgo_id)"
                  >{{ $t("查看详情") }}</el-button
                >
              </div>

              <el-button
                type="primary"
                v-if="item.tgo_status == 50 && !item.is_reviewed"
                class="btn-confirm ml-16"
                @click="showCommentForm(item, 20)"
                >{{ $t("立即评价") }}</el-button
              >
              <el-button
                type="primary"
                v-if="item.tgo_status == 40"
                class="btn-confirm ml-16"
                @click="confirmReceivePrompt(item.tgo_id)"
                >{{ $t("确认收货") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单详情 -->
    <el-dialog
      :title="$t('订单详情')"
      :visible.sync="orderDetailVisible"
      width="727px"
      top="8vh"
      custom-class="order-detail-dialog"
      @close="refreshListAfterDetailClose"
    >
      <div slot="title" class="dialog-title ml-12 fs-18 c-19">
        {{ $t("订单详情")
        }}<span class="fs-18 ml-4">{{ orderDetail.order.tgo_number }}</span>
        <span
          class="iconfont icon-a-svg13 fs-20 ml-6 cup"
          :title="$t('复制订单号')"
          @click="fallbackCopyText(orderDetail.order.tgo_number)"
        ></span>
      </div>

      <!-- 基本信息 -->
      <div class="order-detail-section">
        <div class="section-title">{{ $t("基本信息") }}</div>
        <div class="detail-content">
          <div class="detail-row mt-4">
            <div class="detail-img df aic jcc">
              <img
                :src="orderDetail.goods.tg_main_image_attr"
                class="product-img"
                alt=""
              />
            </div>
          </div>
          <div class="product-info df fww">
            <div class="info-item df fdc">
              <span class="label">{{ $t("商品名称") }}</span>
              <span class="value">{{ orderDetail.goods.tg_name }}</span>
            </div>
            <div class="info-item df fdc">
              <span class="label">{{ $t("商品数量") }}</span>
              <span class="value">{{ orderDetail.order.tge_quantity }}</span>
            </div>
            <div class="info-item df fdc">
              <span class="label">{{ $t("消耗积分") }}</span>
              <span class="value">{{
                orderDetail.order.tgo_total_points
              }}</span>
            </div>
            <div class="info-item df fdc">
              <span class="label">{{ $t("交付状态") }}</span>
              <span class="value status-shipped">{{
                getOrderStatusLabel(orderDetail.order.tgo_status)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 物流信息 -->
      <!-- 判断已发货的才显示物流信息 -->
      <div
        class="order-detail-section mt-20"
        v-if="orderDetail.order.tgo_status > 20"
      >
        <div class="section-title">{{ $t("物流信息") }}</div>
        <div class="detail-content">
          <div class="logistics-info df fww mt-7" v-if="getShipList().length">
            <div
              class="logistics-pair"
              v-for="(ship, sidx) in getShipList()"
              :key="sidx"
            >
              <div class="logistics-row">
                <div class="label">
                  {{ $t(getSegmentLabel(sidx) + "物流公司") }}
                </div>
                <div class="value">
                  {{ ship.ship_label || "-" }}
                </div>
              </div>
              <div class="logistics-row">
                <div class="label">
                  {{ $t(getSegmentLabel(sidx) + "快递单号") }}
                </div>
                <div class="value">
                  {{ ship.ship_info || "-" }}
                  <i
                    class="iconfont icon-a-svg9 fs-22 c-3 ml-8 cup"
                    :title="$t('查看物流')"
                    @click="
                      openLogisticsDetail(
                        ship.ship_company,
                        ship.ship_info,
                        ship.is_international,
                      )
                    "
                  ></i>
                  <i
                    class="iconfont icon-a-svg13 fs-20 c-3 ml-8 cup"
                    :title="$t('复制单号')"
                    @click="copyTrackingNumber(ship.ship_info)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 查看详情-问题反馈 -->
      <div class="order-detail-section mt-20" v-if="orderDetail.feedback">
        <div class="section-title">{{ $t("问题反馈") }}</div>
        <div class="mt-12">
          <div class="feedback-item">
            <div
              class="feedback-question mt-12"
              v-if="orderDetail.feedback.tgof_content"
            >
              <div class="fs-14 c-59 lh-22">{{ $t("问题描述") }}</div>
              <div class="fs-14 lh-22 c-19 mt-4">
                {{ orderDetail.feedback.tgof_content }}
              </div>
            </div>
            <div
              class="feedback-images mt-12"
              v-if="orderDetail.feedback.tgof_images_attr.length"
            >
              <div class="fs-14 c-59 lh-22">{{ $t("图片反馈") }}</div>
              <div class="image-preview df fww mt-4">
                <div
                  class="img-box df aic jcc"
                  v-for="(item, index) in orderDetail.feedback.tgof_images_attr"
                  :key="index"
                >
                  <img :src="item" :alt="$t('反馈图片')" />
                </div>
              </div>
            </div>
            <div
              class="feedback-question mt-12"
              v-if="orderDetail.feedback.tgof_reply"
            >
              <div class="fs-14 c-59 lh-22">{{ $t("反馈答复") }}</div>
              <div class="fs-14 lh-22 c-19 mt-4">
                {{ orderDetail.feedback.tgof_reply }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer df aic jcsb">
        <div class="f1 ta-l">
          <el-button
            v-if="!orderDetail.feedback"
            @click="showFeedbackForm(orderDetail, 10)"
            class="text-btn"
          >
            <span class="iconfont icon-a-svg8 fs-18"></span>
            <span class="fs-12 ml-8 cursor-pointer">{{ $t("问题反馈") }}</span>
          </el-button>
        </div>
        <el-button class="btn-cancel" @click="orderDetailVisible = false">{{
          $t("取消")
        }}</el-button>
          <el-button
            type="primary"
            class="btn-confirm"
            v-if="orderDetail.order && orderDetail.order.tgo_status == 40"
            @click="confirmReceivePrompt(orderDetail.order.tgo_id)"
            >{{ $t("确认收货") }}</el-button
          >

        <!-- <el-button type="primary" class="btn-confirm" @click="showCommentForm"
          >立即评价</el-button
        > -->
      </div>
    </el-dialog>

    <!-- 物流轨迹详情 -->
    <el-dialog
      :title="$t('物流详情')"
      :visible.sync="logisticsDialogVisible"
      width="726px"
      top="8vh"
      custom-class="order-detail-dialog"
    >
      <div class="order-detail-section">
        <div class="section-title">
          <span>{{ getShipperName(logisticsMeta.shipper_code) }}</span>
          <span class="ml-6">{{ logisticsMeta.logistic_code || "-" }}</span>
          <span
            class="ml-6 c-7 fs-14 cup"
            @click="fallbackCopyText(logisticsMeta.logistic_code)"
            >{{ $t("复制") }}</span
          >
        </div>
      </div>
      <div class="order-detail-section" v-if="logisticsLoading">
        <div class="section-title">{{ $t("查询中") }}</div>
        <div class="mt-12">{{ $t("正在查询物流轨迹，请稍候") }}...</div>
      </div>
      <div class="order-detail-section" v-else>
        <div v-if="logisticsError" class="mt-12 c-0">{{ logisticsError }}</div>
        <div v-else class="mt-12">
          <div
            v-if="!logisticsTraces || logisticsTraces.length === 0"
            class="c-59"
          >
            {{ $t("暂无物流轨迹") }}
          </div>

          <div v-else class="trace-list" :class="{ collapsed: isCollapsed }">
            <div
              class="trace-item"
              v-for="(t, idx) in logisticsTraces"
              :key="idx"
              v-show="!isCollapsed || idx < 2"
            >
              <div class="time" :class="{ 'c-FF560A': t.Action == 3 }">
                <span class="fw-b">{{ $t(getLogisticsStatus(t.Action)) }}</span>
                <span class="ml-6 fs-14 c-9">{{ t.AcceptTime }}</span>
              </div>
              <div class="station">
                {{ t.AcceptStation || t.status || t.desc || "-" }}
              </div>
            </div>

            <div class="trace-item cup" @click="handleCollapse">
              <span>{{ $t("收起全部") }}</span>
              <span
                class="iconfont icon-youbian"
                style="position: relative; top: 1px"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 商品评价 -->
    <el-dialog
      :title="commentForm.tgof_type == 10 ? $t('问题反馈') : $t('评价商品')"
      :visible.sync="commentVisible"
      top="80px"
      @close="resetCommentForm"
      width="726px"
      custom-class="order-detail-dialog"
    >
      <!-- 商品详情 -->
      <div class="feedback-info df">
        <div class="img-box w-60 h-60 df aic jcc">
          <img :src="commentForm.tg_main_image_attr" alt="" />
        </div>
        <div
          class="text-box ml-24 lh-24 fs-16 c-19 over-h"
          :title="commentForm.goods_name"
        >
          <div class="t1 one-text">{{ commentForm.goods_name }}</div>
          <div class="df mt-8">
            <span class="">X1</span>
            <div class="ml-40">
              <span class="c-0 fs-14" style="opacity: 0.6"
                >{{ $t("兑换积分") }}：</span
              >
              <span class="ml-2">{{ commentForm.goods_points }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="feedback-form">
        <el-form
          :model="commentForm"
          :rules="commentrules"
          ref="commentFormRef"
          label-position="top"
        >
          <el-form-item
            :label="
              commentForm.tgof_type == 10 ? $t('问题描述') : $t('评价商品')
            "
            prop="content"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="commentForm.content"
              :placeholder="$t('请输入')"
              class="input"
            />
          </el-form-item>
          <el-form-item
            :label="commentForm.tgof_type == 10 ? $t('反馈图片') : $t('晒图片')"
            prop="images"
          >
            <div class="upload-demo">
              <Uploadimg
                v-model="commentForm.images"
                ref="uploadRef"
                :fileLimit="5"
                upType="picture"
                :isUseOss="true"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer df aic jcfe">
        <el-button class="btn-cancel" @click="commentVisible = false">{{
          $t("取消")
        }}</el-button>
        <el-button type="primary" class="btn-submit" @click="submitFeedback">{{
          commentForm.tgof_type == 10 ? $t("提交反馈") : $t("发表评价")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uploadimg from "@comp/Uploadimg/index.vue";
import Uploadcropper from "@comp/UploadCropper/index.vue";

// 引入物流状态数据
import logisticsStatusData from "@/views/personal/data.json";
import {
  getorderList,
  getorderDetail,
  confirmReceive as apiConfirmReceive,
  addOrderFeedback,
  logisticsQuery,
  checkDelivered,
} from "@api/order";

export default {
  name: "Order",
  components: {
    Uploadimg,
    Uploadcropper,
  },
  data() {
    return {
      // 收起
      isCollapsed: false,

      orderDetailVisible: false,
      feedbackVisible: false,
      feedbackrules: {
        description: [
          {
            required: true,
            message: this.$t("请输入问题描述"),
            trigger: "blur",
          },
        ],
      },
      commentVisible: false,
      commentrules: {
        content: [
          {
            required: true,
            message: this.$t("请输入评价商品"),
            trigger: "blur",
          },
        ],
      },
      // 订单列表
      orderList: [],
      // 订单详情
      orderDetail: {
        goods: {},
        order: {},
      },
      feedbackForm: {
        description: "",
        images: [],
      },

      // 评价商品
      commentForm: {
        content: "",
        images: "[]",
        tgof_type: 10, //10=订单问题反馈 20=订单评价
      },
      // 物流弹窗
      logisticsDialogVisible: false,
      logisticsLoading: false,
      logisticsError: "",
      logisticsTraces: [],
      logisticsMeta: { shipper_code: "", logistic_code: "", request_type: "" },
    };
  },
  created() {
    this.getData();
  },
  watch: {
    logisticsDialogVisible(val) {
      if (!val) {
        this.getData();
      }
    },
  },
  methods: {
    resetCommentForm() {
      console.log("this.commentForm");

      this.commentForm.images = "[]";
      this.commentForm.content = "";
      this.commentForm.tgof_type = 10;
    },
    // 收起全部
    handleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    // 根据状态返回物流状态
    getLogisticsStatus(status) {
      return logisticsStatusData.state[status] || status;
    },

    // 根据快递公司返回快递公司名称
    getShipperName(shipperCode) {
      // 获取当前语言
      const lang = this.$i18n.locale;
      if (lang == "zh") {
        return logisticsStatusData.shipper[shipperCode] || shipperCode;
      } else {
        return shipperCode;
      }
    },

    getOrderStatusLabel(s) {
      const map = {
        10: "待处理",
        20: "兑换成功/待发货",
        30: "已发货",
        40: "已送达",
        50: "已签收",
      };
      const txt = map[Number(s)] || String(s || "");
      return this.$t(txt);
    },

    getShipList() {
      const s =
        (this.orderDetail &&
          this.orderDetail.order &&
          this.orderDetail.order.tgo_ship) ||
        "[]";
      if (Array.isArray(s))
        return s.filter((it) => it && (it.ship_company || it.ship_info));
      let arr = [];
      try {
        const parsed = JSON.parse(String(s || "[]"));
        arr = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        arr = [];
      }
      if (!arr || arr.length === 0) {
        const c1 = this.orderDetail?.order?.tgo_ship_company1;
        const i1 = this.orderDetail?.order?.tgo_ship_info1;
        const c2 = this.orderDetail?.order?.tgo_ship_company2;
        const i2 = this.orderDetail?.order?.tgo_ship_info2;
        const tmp = [];
        if (c1 || i1) tmp.push({ ship_company: c1 || "", ship_info: i1 || "" });
        if (c2 || i2) tmp.push({ ship_company: c2 || "", ship_info: i2 || "" });
        arr = tmp;
      }
      return arr.filter((it) => it && (it.ship_company || it.ship_info));
    },

    getSegmentLabel(idx) {
      const arr = [
        "一段",
        "二段",
        "三段",
        "四段",
        "五段",
        "六段",
        "七段",
        "八段",
        "九段",
        "十段",
      ];
      const i = Number(idx) + 1;
      return arr[i - 1] || `${i}段`;
    },

    // 获取订单
    getData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("拼命加载中"),
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      getorderList({}).then((res) => {
        loading.close();
        if (res.status == 200) {
          const list = Array.isArray(res.data) ? res.data : [];
          this.orderList = list.map((it) => {
            const hasFlag = this.computeUnreadFeedback(it);
            return { ...it, has_unread_feedback: hasFlag ? 1 : 0 };
          });
        }
      });
    },
    // 计算某订单是否存在未读的反馈答复
    computeUnreadFeedback(it) {
      if (!it) return false;
      // 后端可能直接返回 has_unread_feedback 字段
      if (it.has_unread_feedback === 1 || it.has_unread_feedback === true)
        return true;
      if (it.has_unread_feedback === 0 || it.has_unread_feedback === false)
        return false;
      // 有些接口可能把反馈对象放在 item.feedback 或 item.order_feedback
      const fb = it.feedback || it.order_feedback || null;
      if (!fb) return false;
      const hasReply = !!fb.tgof_reply;
      const isRead = String(fb.tgof_is_read) === "1";
      return hasReply && !isRead;
    },

    // 查看详情-订单
    showOrderDetail(id) {
      getorderDetail({
        tgo_id: id,
      }).then((res) => {
        if (res.status == 200) {
          this.orderDetail = res.data;
        }
      });
      this.orderDetailVisible = true;
    },
    // 刷新当前订单详情
    refreshOrderDetail() {
      const id =
        this.orderDetail &&
        this.orderDetail.order &&
        this.orderDetail.order.tgo_id;
      if (!id) return;
      getorderDetail({ tgo_id: id }).then((res) => {
        if (res.status == 200) {
          this.orderDetail = res.data;
        }
      });
    },
    // 关闭订单详情后刷新列表，确保未读反馈状态同步
    refreshListAfterDetailClose() {
      this.getData();
    },
    // 立即评价
    showCommentForm(item, type) {
      this.$refs.uploadRef?.resetUpload();
      this.commentVisible = true;
      this.commentForm.tgo_id = item.tgo_id; //名称
      this.commentForm.goods_name = item.goods_name; //名称
      this.commentForm.goods_points = item.goods_points; //积分
      this.commentForm.tg_main_image_attr = item.tg_main_image_attr; //图片
      this.commentForm.tge_quantity = item.tge_quantity; //数量
      this.commentForm.content = ""; //内容
      this.commentForm.images = "[]"; //图片
      this.commentForm.tgof_type = type; //图片
    },

    // 问题反馈
    showFeedbackForm(item, type) {
      this.$refs.uploadRef?.resetUpload();
      this.commentVisible = true;
      this.commentForm.tgo_id = item.order.tgo_id; //名称
      this.commentForm.goods_name = item.goods.tg_name; //名称
      this.commentForm.goods_points = item.goods.tg_points; //积分
      this.commentForm.tg_main_image_attr = item.goods.tg_main_image_attr; //图片
      this.commentForm.tge_quantity = item.order.tge_quantity; //数量
      this.commentForm.content = ""; //内容
      this.commentForm.images = "[]"; //图片
      this.commentForm.tgof_type = type; //图片
    },

    confirmReceivePrompt(id) {
      this.$confirm(
        this.$t("确认后订单将变为已签收，是否确认收货？"),
        this.$t("确认收货"),
        {
          confirmButtonText: this.$t("确认"),
          cancelButtonText: this.$t("取消"),
          type: "warning",
        }
      )
        .then(() => {
          return apiConfirmReceive({ tgo_id: id });
        })
        .then((res) => {
          if (res && res.status == 200) {
            this.$message.success(this.$t("确认收货成功"));
            this.refreshOrderDetail();
            this.getData();
          }
        })
        .catch(() => {});
    },
    copyTrackingNumber(trackingNumber) {
      const text = String(trackingNumber || "").trim();
      if (!text) {
        this.$message.error(this.$t("无有效的快递单号"));
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success(this.$t("复制成功"));
          })
          .catch(() => {
            this.fallbackCopyText(text);
          });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "");
      input.style.position = "absolute";
      input.style.left = "-9999px";
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$message.success(this.$t("复制成功"));
      } catch (e) {
        this.$message.error(this.$t("复制失败，请手动选择复制"));
      }
      document.body.removeChild(input);
    },
    openLogisticsDetail(shipper_code, logistic_code, is_international) {
      const lc = String(logistic_code || "").trim();
      if (!lc) {
        this.$message.error(this.$t("快递单号为空"));
        return;
      }
      this.logisticsMeta = {
        shipper_code: shipper_code || "",
        logistic_code: lc,
        is_international: is_international || 10,
      };
      this.logisticsDialogVisible = true;
      this.logisticsLoading = true;
      this.logisticsError = "";
      this.logisticsTraces = [];

      const phoneRaw = this.orderDetail && this.orderDetail.address && this.orderDetail.address.tua_phone ? String(this.orderDetail.address.tua_phone) : '';
      const phoneLast4 = phoneRaw ? phoneRaw.replace(/\D/g, '').slice(-4) : '';
      logisticsQuery({
        shipper_code: this.logisticsMeta.shipper_code,
        logistic_code: this.logisticsMeta.logistic_code,
        is_international: this.logisticsMeta.is_international,
        customer_name: phoneLast4 || undefined,
      })
        .then((res) => {
          this.logisticsLoading = false;
          // 后端 LogisitcsService 与 Result::disposeServiceRes 的接口风格差异：
          // 即使 status!=200，data 里也可能包含 KDniao 的原始返回
          const ok = res && res.status == 200;
          const payload = res && res.data ? res.data : {};
          const kd = ok ? payload : payload; // 统一使用 data
          // KDniao 标准：Success 布尔、Reason 字段、Traces 数组
          const success = kd && (kd.Success === true || kd.Success === "true");
          if (!success) {
            const msg =
              (res && res.msg) || (kd && kd.Reason) || this.$t("查询失败");
            this.logisticsError = msg;
            this.logisticsTraces = [];
            return;
          }
          this.logisticsTraces = Array.isArray(kd.Traces) ? kd.Traces : [];
          const stateEx = String(kd.StateEx || "");
          const state = String(kd.State || "");
          const signed = ["3", "301", "302", "304", "311"].includes(stateEx) || ["3"].includes(state);
          const id = this.orderDetail?.order?.tgo_id;
          if (signed && id) {
            checkDelivered({ tgo_id: id }).then(() => {
              this.refreshOrderDetail();
            });
          }
        })
        .catch((err) => {
          this.logisticsLoading = false;
          this.logisticsError = this.$t("查询接口异常");
        });
    },

    resetFeedbackForm() {
      this.commentForm.content = "";
      this.commentForm.images = [];
    },

    removeImage(index) {
      this.commentForm.images.splice(index, 1);
    },
    // 规范化前端图片数组为后端期望的结构
    transformImagesForApi(images) {
      const out = [];

      console.log(Array.isArray(images), "........判断是不是数组.....");

      (Array.isArray(images) ? images : []).forEach((it) => {
        if (!it) return;
        if (typeof it === "string") {
          const url = it.trim();
          if (url) out.push({ att_id: 0, att_title: "", att_url: url });
          return;
        }
        if (typeof it === "object") {
          const att_url = it.att_url || it.url || it.path || it.src || "";
          const att_title = it.att_title || it.name || "";
          const att_id = it.att_id || 0;
          if (att_url) out.push({ att_id, att_title, att_url });
        }
      });

      return out.slice(0, 5);
    },
    submitFeedback() {
      if (!this.commentForm.content.trim()) {
        const tipKey = this.commentForm.tgof_type == 10 ? "请输入问题描述" : "请输入评价内容";
        this.$message({
          message: this.$t(tipKey),
          type: "error",
        });
        return;
      }

      const normImages = this.transformImagesForApi(
        JSON.parse(this.commentForm.images)
      );

      addOrderFeedback({
        tgo_id: this.commentForm.tgo_id,
        content: this.commentForm.content,
        images: JSON.stringify(normImages),
        tgof_type: this.commentForm.tgof_type,
      }).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: this.$t("提交成功"),
            type: "success",
          });
          this.commentVisible = false;
          this.resetFeedbackForm();
          // 提交成功后刷新详情，隐藏再次反馈按钮
          this.refreshOrderDetail();
          // 若是商品评价，刷新订单列表，隐藏“立即评价”按钮，防止重复评价
          if (this.commentForm.tgof_type == 20) {
            this.getData();
          }
        }
      });
      // // 提交反馈逻辑
      // this.$message.success("反馈提交成功");
      // this.feedbackVisible = false;
      // this.resetFeedbackForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  line-height: 24px;
  font-family: "MicrosoftYaHeiSemibold";
  position: relative;
  padding-left: 16px;

  .iconfont {
    &:hover {
      color: #a83328;
    }
  }

  &::after {
    content: "";
    display: block;
    width: 4px;
    height: 24px;
    border-radius: 4px;
    background: linear-gradient(
      137.93deg,
      rgba(255, 204, 202, 0),
      rgba(222.12496948242188, 74.20631408691406, 67.11432647705078, 1) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
  }
}

.ipt-box {
  height: 44px;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.15);
  border-radius: 18px;
  width: max-content;
  position: absolute;
  top: -56px;

  &::after {
    content: "\e613";
    font-family: "iconfont";
    font-size: 15px;
    color: #ffffff;
    position: absolute;
    bottom: -11px;
    left: 24px;
  }
}

.feedback-form {
  ::v-deep() {
    .el-textarea__inner {
      min-height: 72px !important;
    }

    .el-upload.el-upload--picture {
      width: 116px;
      height: 116px;
      min-height: 116px;
      border: 1px dashed rgba(201, 201, 201, 1);
      border-radius: 6px;
      position: relative;
      margin-right: 16px;

      .el-upload__text {
        display: none;
      }

      .iconfont {
        color: #fff !important;

        &::after {
          content: "\e623";
          font-family: "iconfont";
          color: #595959;
          font-size: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .el-upload-list--picture .el-upload-list__item {
      width: 116px;
      height: 116px;
      min-height: 116px;
      border: 1px dashed rgba(201, 201, 201, 1);
      border-radius: 6px;
      padding: 0;
      position: relative;
      margin-top: 0;
      margin-right: 16px;
    }

    .el-upload-list--picture .el-upload-list__item-thumbnail {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      margin: 0;
    }

    .el-upload-list__item.is-success .el-upload-list__item-status-label,
    .el-upload-list__item .el-icon-close,
    .el-upload-list__item .el-icon-close-tip {
      z-index: 100;
    }
  }
}

.order-status-timeline {
  max-width: 640px;

  .status-item {
    flex: 1;
    text-align: center;
    margin-right: 16px;
    padding-top: 16px;
    position: relative;

    .yuan {
      padding: 0 10px;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 100;

      &::before {
        display: block;
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        border: 1px solid rgba(174, 174, 174, 1);
      }
    }

    .line {
      &::after {
        content: "";
        display: block;
        width: calc(100% - 16px);
        height: 1px;
        background: #ccc;
        position: absolute;
        top: 4px;
        left: calc(50% + 16px);
      }
    }

    &:last-child {
      margin-right: 0;

      .line::after {
        display: none;
      }
    }

    &:first-child {
      flex: none;

      .line::after {
        width: calc(100% + 100px);
        left: 0%;
        transform: translateX(0%);
      }

      .yuan {
        left: 0;
        transform: translateX(0%);
        padding-left: 0;
      }
    }

    .status-text {
      font-size: 12px;
      line-height: 20px;
      color: #191919;
    }
  }

  &.active-status10,
  &.active-status20 {
    .status-item:nth-child(1) {
      .yuan::before {
        background: #d80f05;
        border-color: #d80f05;
      }

      .status-text {
        color: #d80f05;
      }
    }
  }

  &.active-status30 {
    .status-item:nth-child(-n + 2) {
      .yuan::before {
        border-color: #d80f05;
      }
    }

    .status-item:nth-child(2) {
      .yuan::before {
        background: #d80f05;
      }

      .status-text {
        color: #d80f05;
      }
    }

    .status-item:nth-child(-n + 1) {
      .line::after {
        background: #d80f05;
      }
    }
  }

  &.active-status40 {
    .status-item:nth-child(-n + 3) {
      .yuan::before {
        border-color: #d80f05;
      }
    }

    .status-item:nth-child(3) {
      .yuan::before {
        background: #d80f05;
      }

      .status-text {
        color: #d80f05;
      }
    }

    .status-item:nth-child(-n + 2) {
      .line::after {
        background: #d80f05;
      }
    }
  }

  &.active-status50 {
    .status-item:nth-child(-n + 4) {
      .yuan::before {
        border-color: #d80f05;
      }
    }

    .status-item:nth-child(4) {
      .yuan::before {
        background: #d80f05;
      }

      .status-text {
        color: #d80f05;
      }
    }

    .status-item:nth-child(-n + 3) {
      .line::after {
        background: #d80f05;
      }
    }
  }
}

.order-actions {
  margin-left: 12px;

  button {
    font-size: 12px;
  }

  .btn-detail {
    min-width: 92px;
    height: 32px;
    line-height: 30px !important;
    padding: 0 16px;
    border: 1px solid rgba(174, 174, 174, 1);
    border-radius: 23px;
    color: #000;

    &:hover {
      border-color: #b7251e;
      color: #b7251e;
    }
  }

  .btn-confirm {
    min-width: 92px;
    border-radius: 30px;
    height: 32px;
    padding: 0 16px;
  }
}

.order-list {
  margin-top: 29px;

  .box2 {
    margin-top: 16px;

    .good-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
  }

  .order-item {
    border: 0.5px solid rgba(201, 201, 201, 1);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px;
  }
}

.title {
  color: rgba(25, 25, 25, 1);
  font-family: "MicrosoftYaHeiSemibold";
  font-size: 20px;
  line-height: 24px;
}

/* 订单详情弹窗样式 */
.dialog-footer {
  button {
    font-size: 12px;
    height: 32px;
    min-width: 92px;
    border-radius: 30px;
    padding: 0 16px;
  }

  .text-btn {
    min-width: auto;
    padding: 0;
    border: none;
    color: #191919;

    .iconfont {
      position: relative;
      top: 2px;
    }

    &:hover {
      background: transparent;
      color: #b7251e;
    }
  }

  .btn-cancel {
    border-color: rgba(174, 174, 174, 1);
    color: rgba(0, 0, 0, 1);
    transition: all 0.16s;

    &:hover {
      border-color: #b7251e;
      color: #b7251e;
    }
  }

  .btn-confirm {
    padding: 0 16px;
  }
}

.feedback-form {
  margin-top: 16px;

  ::v-deep() {
    .el-form--label-top .el-form-item__label {
      color: rgba(89, 89, 89, 1);
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      padding-bottom: 4px;
    }

    .el-form-item {
      margin-bottom: 18px;
    }
  }
}

.feedback-info {
  height: 92px;
  position: relative;
  padding: 16px 20px;
  z-index: 10;

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: linear-gradient(
      -64.32deg,
      rgba(196, 196, 196, 0),
      rgba(255, 0, 0, 0.11) 100%
    );
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}

.order-detail-section {
  .feedback-images {
    .image-preview .img-box {
      width: 60px;
      height: 60px;
      margin-right: 12px;

      img {
        width: 60px;
        height: 60px;
        object-fit: cover;
      }
    }
  }

  .logistics-info {
    font-family: "harmonyos";

    .logistics-pair {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .logistics-row {
      width: 50%;
      margin-bottom: 16px;
      margin-top: 4px;

      .label {
        color: rgba(89, 89, 89, 1);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }

      .value {
        color: rgba(25, 25, 25, 1);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 4px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .cup {
          cursor: pointer;
        }

        .ml-8 {
          margin-left: 8px;
        }

        i {
          color: #8f8f8f;
        }

        i:hover {
          color: #b7251e !important;
        }
      }
    }
  }

  .section-title {
    color: rgba(25, 25, 25, 1);
    font-family: "harmonyos";
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  .product-info {
    font-family: "harmonyos";
    margin-top: 9px;

    .info-item {
      width: 50%;
      margin-bottom: 16px;

      .label {
        color: rgba(89, 89, 89, 1);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }

      .value {
        color: rgba(25, 25, 25, 1);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 4px;
      }
    }
  }

  .detail-row {
    .detail-img {
      width: 60px;
      height: 60px;
    }

    img {
      max-width: 60px;
      max-height: 60px;
      border-radius: 4px;
    }
  }
}

.trace-list {
  .trace-item {
    margin-bottom: 10px;
    position: relative;
    padding-left: 26px;

    .c-FF560A {
      color: #ff560a !important;
    }

    &::before {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #ebebeb;
      position: absolute;
      top: 7px;
      left: 0;
    }

    &::after {
      content: "";
      display: block;
      width: 1px;
      height: calc(100% + 6px);
      background: #ebebeb;
      position: absolute;
      top: 13px;
      left: 6px;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }

    .time {
      font-size: 16px;
    }

    .station {
      font-size: 14px;
      color: #999;
    }
  }
}

::v-deep() {
  .order-detail-dialog {
    .el-icon-close:before {
      font-size: 20px;
    }

    .el-dialog__footer {
      padding: 22px 32px;
    }

    &.el-dialog {
      border-radius: 12px;
      box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
    }

    .el-dialog__body {
      padding: 16px 32px;
      // max-height: calc(100vh - 210px);
      // overflow: hidden;
      // overflow-y: scroll;
    }
  }
}
</style>
